// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"bd5a1381","323":"61570590","453":"54292a4b","970":"fc59184f"}[chunkId] + ".chunk.js";
};